export function AudioRecorder({ recordingStarted, recordingStopped }) {
    let audioContext = null;
    let processor = null;
    let input = null;
    let mediaStream = null;
    let audioData = {
        size: 0,           // total bytes de dados PCM
        buffer: [],        // array de Float32Arrays
        sampleRate: 0
    };
    let isRecording = false;

    async function startRecording() {
        if (isRecording) return;

        try {
            mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
            audioData.sampleRate = audioContext.sampleRate;
            input = audioContext.createMediaStreamSource(mediaStream);

            // ScriptProcessorNode está obsoleto em alguns browsers, mas tem suporte amplo.
            const bufferSize = 4096;
            processor = audioContext.createScriptProcessor(bufferSize, 1, 1);

            processor.onaudioprocess = (e) => {
                const channelData = e.inputBuffer.getChannelData(0);
                // clonamos porque o buffer é reaproveitado internamente
                audioData.buffer.push(new Float32Array(channelData));
                audioData.size += channelData.length * 2; // 2 bytes por amostra 16-bit
            };

            input.connect(processor);
            processor.connect(audioContext.destination); // necessário para disparar o onaudioprocess

            isRecording = true;
            if (recordingStarted) recordingStarted();

        } catch (err) {
            console.error('Erro ao iniciar gravação WAV:', err);
            throw new Error('Não foi possível acessar o microfone. Verifique as permissões.');
        }
    }

    function stopRecording() {
        if (!isRecording) return;

        // Disconnect nodes
        processor.disconnect();
        input.disconnect();
        mediaStream.getTracks().forEach(t => t.stop());
        audioContext.close();

        // Montar WAV
        const wavBlob = encodeWAV(audioData.buffer, audioData.size, audioData.sampleRate);

        // Limpar buffers
        audioData.buffer = [];
        audioData.size = 0;

        isRecording = false;
        if (recordingStopped) recordingStopped(wavBlob);
    }

    function toggleRecording() {
        if (isRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    }

    return {
        startRecording,
        stopRecording,
        toggleRecording,
        get isRecording() { return isRecording; }
    };
}

// Função utilitária para encodar PCM Float32Array em WAV 16-bit little endian
function encodeWAV(buffers, totalBytes, sampleRate) {
    const headerBytes = 44;
    const buffer = new ArrayBuffer(headerBytes + totalBytes);
    const view = new DataView(buffer);

    // RIFF identifier
    writeString(view, 0, 'RIFF');
    // file length minus first 8 bytes
    view.setUint32(4, 36 + totalBytes, true);
    // WAV identifier
    writeString(view, 8, 'WAVE');
    // fmt chunk
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);              // fmt chunk length
    view.setUint16(20, 1, true);               // PCM (uncompressed)
    view.setUint16(22, 1, true);               // mono = 1 canal
    view.setUint32(24, sampleRate, true);      // sample rate
    view.setUint32(28, sampleRate * 2, true);  // byte rate = sampleRate * blockAlign
    view.setUint16(32, 2, true);               // block align = numChannels * bytesPerSample
    view.setUint16(34, 16, true);              // bitsPerSample
    // data chunk
    writeString(view, 36, 'data');
    view.setUint32(40, totalBytes, true);

    // Write PCM samples
    let offset = headerBytes;
    for (let i = 0; i < buffers.length; i++) {
        const buf = buffers[i];
        for (let j = 0; j < buf.length; j++, offset += 2) {
            // converter Float32 [-1..1] para int16
            let s = Math.max(-1, Math.min(1, buf[j]));
            s = s < 0 ? s * 0x8000 : s * 0x7FFF;
            view.setInt16(offset, s, true);
        }
    }

    return new Blob([view], { type: 'audio/wav' });
}

function writeString(view, offset, str) {
    for (let i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
    }
}
